import Button from "@/components/ui/Button";
import { useAuth } from "@/hooks/auth/useAuth";
import { logout } from "@/app/providers/authActions";
import { useNavigate } from "react-router-dom";
import { useMyTours } from "@/hooks/tours/useMyTours";
import { FLAGSHIP_TOUR_ID } from "@/app/routing/tourRoutes";

export default function UserMenu() {
  const { user, firebaseUser, loading } = useAuth();
  const navigate = useNavigate();
  const { tours } = useMyTours(firebaseUser?.uid);

  if (loading || !firebaseUser) return null;

  const displayName =
    user?.displayName || firebaseUser.displayName || firebaseUser.email;

  async function handleLogout() {
    await logout();
  }

  return (
    <div className="flex items-center gap-3">
      {tours.length > 1 && <select aria-label="Switch tour" onChange={event => navigate(event.target.value === FLAGSHIP_TOUR_ID ? "/" : `/${event.target.value}`)} className="max-w-36 rounded-lg border border-black/10 bg-white px-2 py-1 text-xs text-text"><option value="">Switch tour</option>{tours.map(tour => <option key={tour.id} value={tour.id}>{tour.name}</option>)}</select>}
      <div className="text-sm text-muted">{displayName}</div>

      <Button variant="ghost" size="sm" onClick={handleLogout}>
        Sign Out
      </Button>
    </div>
  );
}
